import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import { GridComponent, TooltipComponent, LegendComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { EmptyState } from '@/components/custom/empty-state';

echarts.use([LineChart, GridComponent, TooltipComponent, LegendComponent, CanvasRenderer]);

export function UsageLineChart({ categories = [], series = [] }) {
  const [option, setOption] = useState({});

  useEffect(() => {
    if (!series.length) return;

    setOption({
      backgroundColor: 'transparent',
      grid: {
        left: 15,
        right: '3%',
        bottom: '15%',
        top: '10%',
        containLabel: true
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderWidth: 0,
        shadowColor: 'rgba(0, 0, 0, 0.1)',
        shadowBlur: 10,
        textStyle: { color: '#666' }
      },
      legend: {
        show: true,
        bottom: 0,
        icon: 'roundRect',
        itemWidth: 20,
        itemHeight: 2,
        textStyle: { color: '#8894AC', fontSize: 12 }
      },
      xAxis: {
        type: 'category',
        data: categories,
        boundaryGap: false,
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { color: '#999', fontSize: 11, margin: 20 }
      },
      yAxis: {
        type: 'value',
        min: 0,
        axisLabel: { color: '#999', fontSize: 11, margin: 20 },
        splitLine: { lineStyle: { color: '#ECE9F8' } }
      },
      series: series.map(item => ({
        name: item.label,
        type: 'line',
        data: item.data,
        smooth: false,
        connectNulls: true,
        lineStyle: { width: 2, color: item.color },
        itemStyle: { color: item.color },
        symbol: 'circle',
        showSymbol: true,
        symbolSize: 6
      }))
    });
  }, [categories, series]);

  if (!series.length) {
    return (
      <EmptyState
        type="data"
        variant="plain"
        text="Nenhum dado disponível"
      />
    );
  }

  return (
    <ReactECharts
      option={option}
      echarts={echarts}
      style={{ height: 300, width: '100%' }}
      notMerge={true}
    />
  );
}
